import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "amfe-flexible";
import Vant, { Lazyload } from "vant";
import "vant/lib/index.css";
import echarts from "echarts";
import "@/style/index.css";
import "./style/img.css";
import comview from "./components/index";
Vue.use(Lazyload, {
  lazyComponent: true
});
Vue.prototype.$echarts = echarts;
Vue.prototype.$token = window.localStorage.getItem("tenantId");
Vue.use(Vant);

for (const i in comview) {
  Vue.component(i, comview[i]);
}
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
Vue.config.devtools = false;
